import { render, staticRenderFns } from "./AdminLoginProperty.vue?vue&type=template&id=fe52f986"
import script from "./AdminLoginProperty.vue?vue&type=script&lang=js"
export * from "./AdminLoginProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports